import { useEffect, useState, useRef } from 'react';
import OdooDatabase from '../../data/odoo';
import Loading from '../LoadingComponent';
import TableList from '../TableListViewComponent';
import SignatureCanvas from "react-signature-canvas";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import '../css/signatures.css'

type QuoteReportProperties = {
    workorder_id: number;
    onOK?(): void;
    onClose?(): void;
}

export default function QuoteReportComponent(props: QuoteReportProperties) {
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState<any>(null);
    const [signatureTypes, setSignatureTypes] = useState<Array<any>>([]);
    const [workDescription, setWorkDescription] = useState<string>("");
    const [alreadySigned, setAlreadySigned] = useState<boolean>(false);
    let signatureReferences: any[] = []
    const mountedRef = useRef(true);

    const loadData = async () => {
        const odoo = OdooDatabase.getInstance();
        try{
            setLoading(true)
            let data = await odoo.execute_kw('fieldservice.workorder', 'get_quote_price_report', [[props.workorder_id]]);
            setReportData(data);
            const sigTypes = await odoo.execute_kw('fieldservice.signature', 'get_on_site_approval_signatures', [[props.workorder_id]]);
            for(const sigType of sigTypes) {
                if (sigType.description) {
                    setWorkDescription(sigType.description);
                }
                if (sigType.data) {
                    setAlreadySigned(true);
                }
            }
            setSignatureTypes(sigTypes);
            if (!mountedRef.current) return
            setLoading(false)
        }catch(err: any){
            console.log('Error', err);
            if (!mountedRef.current) return
            setLoading(false)
        }
    };

    useEffect(() => {
        loadData()
        return () => {
            mountedRef.current = false
        }
    // eslint-disable-next-line
    }, []);

    const saveSignature = async () => {
        const odoo = OdooDatabase.getInstance();
        try{
            setLoading(true);
            const signaturesData = [];
            for (let signatureReference of signatureReferences) {
                if (signatureReference.ref.isEmpty()) {
                    alert(`Signature ${signatureReference.name} is missing`);
                }
                const data = signatureReference.ref.toDataURL().split(',')[1];
                signaturesData.push({type_id: signatureReference.id, data: data, description: workDescription});
            }
            await odoo.execute_kw('fieldservice.signature', 'save_on_site_approval_signatures', [[props.workorder_id, signaturesData]]);
            if (!mountedRef.current) return
            setLoading(false);
            if (props.onOK) {
                props.onOK();
            }
        }
        catch(err: any){
            console.log('Error', err);
            if (!mountedRef.current) return
            setLoading(false);
            alert('Error saving signatures: ' + err.message);
            if (props.onClose) {
                props.onClose();
            }
        }
    }

    const resetSignature = (signatureId: number) => {
        for (let signatureReference of signatureReferences) {
            if (signatureReference.id === signatureId) {
                signatureReference.ref.clear();
            }
        }
    }

    const signatureItems = signatureTypes.map((sigType: any) => {
        return (
            <div key={sigType.id}>
                <Typography>{sigType.name}</Typography>
                <div className='signature_item'>
                    {
                        sigType.data ? (<><img alt={sigType.name} src={`data:image/png;base64,${sigType.data}`}/></>) : 
                        (<>
                            <SignatureCanvas canvasProps={{width: '420vw', height: 250, className: 'sigCanvas'}} penColor='#2C649F'
                                ref={(ref: any) => { signatureReferences.push({id: sigType.id, ref: ref, name: sigType.name}); }}
                            />
                            <div><Button color="primary" variant="contained" onClick={() => {resetSignature(sigType.id)}}>Reset</Button></div>
                        </>)
                    }
                    
                </div>
            </div>
        );
    });

    if (loading) {
        return (<Loading loading={true} fullWidth={false}/>)
    }
    else if(reportData){

        return (
            <div className="quote_report_container">
                <div>
                    <strong>WO: </strong>{reportData.wo_name}
                    <br/>
                    <strong>Site: </strong>{reportData.site_name}
                    <br/>
                    <strong>Customer: </strong>{reportData.customer_name}
                </div>
              
                <div>
                    {
                        alreadySigned ? (<p>{workDescription}</p>) : 
                        (
                            <TextField
                                id="on_site_approval_scope_of_work"
                                label="Work Description"
                                multiline
                                rows={4}
                                fullWidth={true}
                                value={workDescription}
                                onChange={(e) => setWorkDescription(e.target.value)}
                                variant="standard"
                            />
                        )
                    }
                </div> 
                {signatureItems}
                <div className="wo_app_buttons">
                    {
                        alreadySigned ? (<></>) : 
                        (<Button autoFocus onClick={saveSignature} variant="contained" color="primary">Save</Button>)
                    }
                    
                    {
                        props.onClose ? (
                            <Button autoFocus onClick={() => {if (props.onClose) props.onClose();} } variant="contained">Cancel</Button>
                        ) : (<></>)
                    }
                </div>
            </div>
        )
    } else {
        return (<></>);
    }
}